import PropTypes from 'prop-types';
import { useRef, useEffect, memo } from 'react';

import { RefType } from '../../api/types';
import { FormattedOdds } from '../formatted-odds/formatted-odds';

import './animated-odd.scss';

export const CLASSES = {
  INCREASE: 'increase',
  DECREASE: 'decrease',
};

export const ARROW_VISIBILITY_TIME = 5600;

export function AnimatedOddUI({ className, odds, wrapperRef }) {
  const rootRef = useRef();
  const prevOddsRef = useRef(odds);

  useEffect(() => {
    const rank = odds - prevOddsRef.current;

    prevOddsRef.current = odds;

    if (rank === 0) return undefined;

    const rootEl = rootRef.current;
    const wrapperEl = wrapperRef.current;
    const rankClassName = rank > 0 ? CLASSES.INCREASE : CLASSES.DECREASE;

    rootEl.classList.add(`sb-AnimatedOdd-${rankClassName}`);

    if (wrapperEl) wrapperEl.classList.add(`sb-AnimatedOdd-wrapper-${rankClassName}`);

    let timeoutId;
    const finishAnimation = isCancelled => {
      rootEl.classList.remove(`sb-AnimatedOdd-${rankClassName}`);

      if (wrapperEl) wrapperEl.classList.remove(`sb-AnimatedOdd-wrapper-${rankClassName}`);

      // when odds change happens before current animation has finished,
      // we manually finish current animation and trigger browser to recalculate styles
      if (isCancelled && timeoutId) {
        clearTimeout(timeoutId);
        // eslint-disable-next-line no-unused-expressions
        wrapperEl ? wrapperEl.scrollTop : rootEl.scrollTop;
      }

      timeoutId = undefined;
    };

    timeoutId = setTimeout(finishAnimation, ARROW_VISIBILITY_TIME);

    return () => finishAnimation(true);
  }, [odds]);

  return (
    <div ref={rootRef} className={`sb-AnimatedOdd${className ? ` ${className}` : ''}`} data-test-id="animated-odd">
      <FormattedOdds odds={odds} />
    </div>
  );
}

AnimatedOddUI.propTypes = {
  className: PropTypes.string,
  odds: PropTypes.number,
  wrapperRef: RefType.isRequired,
};

AnimatedOddUI.defaultProps = {
  odds: undefined,
  className: undefined,
};

export const AnimatedOdd = memo(AnimatedOddUI);
